<template>
  <div>
    <form>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <label class="col-form-label control-label required">{{
              $t('restaurantSale.dateRange')
            }}</label>
            <a-range-picker
              style="width:100%"
              v-model="model.date_range"
              valueFormat="DD-MM-YYYY HH:mm"
              :show-time="{ format: 'HH:mm' }"
              format="DD-MM-YYYY HH:mm"
            />
            <div class="validate" v-if="errors.has('date_range')">
              {{ errors.first('date_range') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group">
          <div class="col-md-12">
            <a-radio-group v-model="model.print">
              <a-radio value="a4">A4</a-radio>
              <a-radio value="receipt">Receipt</a-radio>
            </a-radio-group>
          </div>
        </div>
      </div>
      <div class="row" v-if="is_required_pwd">
        <div class="form-group">
          <div class="col-md-12">
            <fieldset>
              <legend class="text-black">
                {{ $t('restaurantSale.adminConfirm') }}
              </legend>
              <div
                class="alert alert-danger fade show ts-mb-4"
                v-show="errorMessage != ''"
              >
                {{ errorMessage }}
              </div>
              <div class="row form-group">
                <label class="col-form-label control-label required">
                  {{ $t('restaurantSale.username') }}</label
                >
                <input
                  type="text"
                  :placeholder="$t('restaurantSale.username')"
                  class="form-control form-control-md input-login"
                  :class="{ 'is-invalid': errors.has('user_name') }"
                  v-model="model.user_name"
                />
                <div class="invalid-feedback" v-if="errors.has('user_name')">
                  {{ errors.first('user_name') }}
                </div>
              </div>
              <div class="row form-group">
                <label class="col-form-label control-label required">{{
                  $t('restaurantSale.password')
                }}</label>
                <a-input-password
                  :placeholder="$t('restaurantSale.password')"
                  v-model="model.password"
                />
                <div class="validate" v-if="errors.has('password')">
                  {{ errors.first('password') }}
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button
            type="submit"
            class="btn-lg btn-block"
            color="primary"
            @click.prevent="ok"
            :waiting="waiting"
            >{{ $t('ok') }}</ts-button
          >
        </div>
      </div>
    </form>
    <reciept-preview
      v-model="pdf_view"
      :src_pdf="src"
      :show="pdf_view"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import RecieptPreview from './reciept-preview'

export default {
  name: 'shiftClose',
  components: {
    RecieptPreview
  },
  data () {
    return {
      model: {
        counter_id: parseInt(localStorage.getItem('counterId')),
        print: 'receipt',
        user_name: null,
        password: null,
        is_admin_password: true,
        date_range: [
          moment().startOf('day').format('DD-MM-YYYY HH:mm'),
          moment().endOf('day').format('DD-MM-YYYY HH:mm')
        ]
      },
      waiting: false,
      errorMessage: '',
      pdf_view: false,
      src: '',
      errors: new Errors()
    }
  },
  computed: {
    is_required_pwd () {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .is_close_shift_require_pwd
    }
  },
  methods: {
    ok () {
      this.errors = new Errors()
      this.errorMessage = ''
      this.waiting = true
      this.model.is_admin_password = this.is_required_pwd
      this.$store
        .dispatch('restaurantSale/counterCheckout/shiftClose', this.model)
        .then(response => {
          this.pdf_view = true
          this.src = response.url
        })
        .catch(errorResponse => {
          if (errorResponse.errors) {
            this.errors = new Errors(errorResponse.errors)
          } else if (errorResponse.message) {
            this.errorMessage = errorResponse.message
          }
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async logout () {
      await this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    },
    cancel () {
      this.pdf_view = false
      this.$emit('cancel')
      this.logout()
    }
  }
}
</script>
<style scoped>
.btn-row .btn {
  padding: 15px 20px;
  font-size: 0.875rem;
  min-width: 100px;
  text-align: center;
  position: relative;
  border-radius: 0;
}
fieldset {
  border: 1px solid #ececec;
  padding: 10px 15px !important;
  border-radius: 4px;
}
</style>
